<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">诊疗中列表</div>
				<div class="titleR">
					
				</div>
			</div>
			<div class="content">
				<div class="con">
					<!-- <div class="tabLine">
						<div class="tabLineL">
							
						</div>
						<div class="tabLineR">
							
						</div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							
						</div>
						<div class="searchLineR"></div>
					</div> -->
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="单号" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.recordId}}</div>
								</template>
							</el-table-column>
							<el-table-column label="顾客" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.memberName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="手机号" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.memberMobile}}</div>
								</template>
							</el-table-column>
							<el-table-column label="宠物" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.petName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="品种" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.typeName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="宠物性别" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.sex}}</div>
								</template>
							</el-table-column>
							<el-table-column label="医生" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.doctorName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="科室" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.departmentName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="金额" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.totalMoney}}</div>
								</template>
							</el-table-column>
							<el-table-column label="时间" min-width="50">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" min-width="50">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="see_jiezhen(props.row)">
										查看
									</el-button>
									<el-button
										v-show="$buttonAuthority('yewu-yiliaoxin-jiezhen')"
										v-if="props.row.status==1&&(!props.row.doctorId||userInfo.staffId===props.row.doctorId)"
										type="text" @click="jiezhen(props.row)" size="mini">
										接诊
									</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-jiezhen')"
										v-if="props.row.status==1&&(props.row.doctorId&&userInfo.staffId!==props.row.doctorId)"
										type="text" disabled size="mini">
										接诊
									</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-editjiezhen')"
										v-if="props.row.status==2"
										type="text" @click="toBingliEdit_jiezhen(props.row)" size="mini">
										编辑
									</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-del')"
										v-if="props.row.status==1"
										type="text" @click="delJie_jiezhen(props.row)" size="mini">
										删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
		<el-dialog title="" :visible.sync="dialogJiezhen_state" width="30%">
			<div>
				<el-form ref="form" label-width="80px">
					<el-form-item label="接诊医生: ">
						<div class="xmjBox">
							<div class="xmjItem" :class="curDoctor===item.userId?'active':''" @click="curDoctor = item.userId" v-for="(item) in doctorList" :key="item.userId">
								{{item.userName}}
							</div>
						</div>
						<!-- <el-select v-model="curDoctor" placeholder="请选择" size="mini">
							<el-option v-for="item in doctorList" :key="item.userId" :label="item.userName" :value="item.userId"> </el-option>
						</el-select> -->
					</el-form-item>
				</el-form>
				<div style="font-size: 16px;padding-left:10px;padding-bottom: 10px;">确定要用以上医生接诊吗？</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogJiezhen_state = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="submit_jiezhen" size="mini">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				
				// 接诊
				curRow:null,
				dialogJiezhen_state: false,
				doctorList:[],
				curDoctor:'',
			}
		},
		computed:{
			loginInfo(){
				return this.$store.state.userInfo
			},
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			rightInRegistrationParams(){
				return this.$store.state.yiliaoxin.rightInRegistrationParams
			}
		},
		created(){
			
		},
		mounted(){
			this.page = this.rightInRegistrationParams.initialDataOflist.page||this.page;
			this.getTableData();
		},
		methods: {
			// 查看
			see_jiezhen(row){
				let obj = this.$store.state.yiliaoxin.jiezhenParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_jiezhenParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'接诊')
				this.$store.commit("yiliaoxin/add_router",{name:'接诊',data:obj})
			},
			// 编辑 
			toBingliEdit_jiezhen(row){
				let obj = this.$store.state.yiliaoxin.bingliParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_bingliParams",obj)
				this.$store.commit('yiliaoxin/set_curBusiness','病例')
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
			},
			// 删除
			delJie_jiezhen(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/Registration/Delete', {recordId:row.recordId}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getGuahaoList()
						}
					})
				})
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"status": 2, // 1待接诊；2已接诊；3已完成
					"is_mine": false,
					"begin_time": "",
					"end_time": "",
					isPay:1,
					desc:true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ''
				}
				let loading=this.$loading();
				this.$http.post('/api/Registration/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.rightInRegistrationParams.initialDataOflist = {
					page:JSON.parse(JSON.stringify(this.page)),
				}
				this.$store.commit("yiliaoxin/set_rightInRegistrationParams",JSON.parse(JSON.stringify(this.rightInRegistrationParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'rJiezhenZhong',data:JSON.parse(JSON.stringify(this.rightInRegistrationParams))})
			},
			// 接诊
			jiezhen(row){
				this.curRow = row;
				let curDoctor = ''
				for(let i=0;i<this.doctorList.length;i++){
					if(this.doctorList[i].userId === this.userInfo.staffId){
						curDoctor = this.userInfo.staffId;
					}
				}
				this.curDoctor = curDoctor;
				this.dialogJiezhen_state = true;
				this.getDoctorList()
			},
			submit_jiezhen(){
				if(this.$public.isNull(this.curDoctor)){
					this.$message({
						message: '请选择接诊医生',
						type: 'error'
					});
					return ;
				}
				let params = {
					recordId:this.curRow.recordId,
					doctorId:this.curDoctor,
					doctorName:this.$public.getMatchingItem(this.doctorList,'userId',this.curDoctor).userName,
				}
				this.$http.get('/api/Case/ReceptionCase', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '接诊成功',
							type: 'success'
						});
						this.dialogJiezhen_state = false;
						this.getGuahaoList()
						
						let obj = this.$store.state.yiliaoxin.bingliParams
						obj.curRow = res.data
						obj.type = 'edit'
						this.$store.commit("yiliaoxin/set_bingliParams",obj)
						this.$store.commit('yiliaoxin/set_curBusiness','病例')
						this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
					}
				})
			},
			getDoctorList() {
				let params = {
					"date": '', // 10位时间戳
				}
				this.$http.get('/api/Registration/DutyForDay', params).then(res => {
					if (res.code == 0) {
						this.doctorList = res.data;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
